import(/* webpackMode: "eager" */ "/github/workspace/src/app/template.tsx");
